import type { Component } from "solid-js";
import { useTranslation } from "../state/i18n";
import { isNil } from "lodash-es";

const CrowdinInContextPage: Component = () => {
  const { changeLanguage } = useTranslation();
  const crowdinInContext = localStorage.getItem("crowdinInContext");

  if (isNil(crowdinInContext) || crowdinInContext === "false") {
    localStorage.setItem("crowdinInContext", "true");
    void changeLanguage("lol");
  } else {
    localStorage.setItem("crowdinInContext", "false");
    void changeLanguage("en");
  }

  setTimeout(() => {
    // Force hard reload
    window.location.href = "/";
  }, 5000);

  return (
    <div>
      <p>
        Turned {crowdinInContext === "true" ? "off" : "on"} Crowdin In-Context translation mode, redirecting back to the
        Platform in 5 seconds...
      </p>
    </div>
  );
};

export default CrowdinInContextPage;
